var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThankuCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3602 63.6697C40.8348 65.1443 43.2257 65.1443 44.7003 63.6697L70.0326 38.3373C71.5072 36.8627 71.5072 34.4718 70.0326 32.9972C68.558 31.5226 66.1671 31.5226 64.6925 32.9972L42.0302 55.6595L32.6409 46.2703C31.1663 44.7957 28.7754 44.7957 27.3008 46.2704C25.8262 47.745 25.8262 50.1359 27.3008 51.6105L39.3602 63.6697Z",
    fill: "#0D781E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333374 48.3332C0.333374 75.0269 21.973 96.6665 48.6667 96.6665C75.3604 96.6665 97 75.0269 97 48.3332C97 21.6395 75.3604 -0.0001297 48.6667 -0.0001297C21.973 -0.0001297 0.333374 21.6395 0.333374 48.3332ZM48.6667 89.1144C26.1439 89.1144 7.88545 70.856 7.88545 48.3332C7.88545 25.8104 26.1439 7.55195 48.6667 7.55195C71.1895 7.55195 89.4479 25.8104 89.4479 48.3332C89.4479 70.856 71.1895 89.1144 48.6667 89.1144Z",
    fill: "#0D781E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankuCheck);
export default __webpack_public_path__ + "static/media/thanku-check.18918835af3f69b1cf6c0b3dece62527.svg";
export { ForwardRef as ReactComponent };